import axios from 'axios'
import { headersTokenConfig } from '../config/HeaderToken'

class BonusPoint {
  workers(page, limit, search) {
    const endPoint = `/mutasi-point/worker?page=${page}&limit=${limit}`
    let url = process.env.REACT_APP_API_URL_V2 + endPoint

    if (search) {
      url = process.env.REACT_APP_API_URL_V2 + endPoint + `&search=${search}`
    }

    return axios.get(url, headersTokenConfig)
  }

  detail(id, page, limit) {
    const params = `page=${page}&limit=${limit}`
    const url = process.env.REACT_APP_API_URL_V2 + `/mutasi-point/worker/${id}/detail?${params}`
    return axios.get(url, headersTokenConfig)
  }

  request(page, limit, search, type, status, start_date, end_date){
    const filter_search = search ? `&search=${search}` : ''
    const filter_type = type ? `&type=${type}` : ''
    const filter_status = status.length > 0 ? `&status=${status.join(',')}` : ''
    const filter_start = start_date ? `&start_date=${start_date}` : ''
    const filter_end = end_date ? `&end_date=${end_date}` : ''

    const params = `page=${page}&limit=${limit}${filter_search}${filter_type}${filter_status}${filter_start}${filter_end}`
    const url = process.env.REACT_APP_API_URL_V2 + `/pencairan-point/worker?${params}`
    return axios.get(url, headersTokenConfig)
  }

  allWorkers() {
    const url = process.env.REACT_APP_API_URL_V1 + `/mutasi-point/all-worker`
    return axios.get(url, headersTokenConfig)
  }
}

export default new BonusPoint()
